import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
//
import { Scrollbar } from 'components';
import { CloseIcon } from 'components/SvgIcons';
import { Checkbox } from '../Checkbox';
import ArrowDown from './arrow-down.svg';

import './index.scss';

class DropdownMultiWithTags extends PureComponent {
  constructor(props) {
    super(props);

    const { initMessage } = props;

    this.state = {
      listOpen: false,
      headerTitle: initMessage,
      searchValue: '',
      inSearch: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const result = {};
    const { initMessage } = nextProps;

    if (JSON.stringify(nextProps.value) !== JSON.stringify(prevState.value)) {
      const itemsArr = [];
      const titleArr = [];
      const helpArr = [...nextProps.value];

      if (nextProps.list.length > 0) {
        helpArr.map((item) => {
          const newObjectItem = (nextProps.list || []).find(
            (listItem) => listItem.value === item || +listItem.value === +item,
          );
          if (newObjectItem !== undefined) {
            itemsArr.push(newObjectItem);
          }
        });
        itemsArr.length &&
          itemsArr.map((item) => titleArr.push(item.title || ''));
        result.value = nextProps.value;
        result.headerTitle =
          titleArr.length > 0
            ? titleArr
            : initMessage !== ''
            ? initMessage.split(',')
            : [];
      }
    }
    return result;
  }

  componentDidUpdate(prevProps, prevState) {
    const { listOpen } = this.state;

    setTimeout(() => {
      if (listOpen) {
        window.addEventListener('click', this.close);
      } else {
        window.removeEventListener('click', this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.close);
  }

  close = () => {
    this.setState({
      listOpen: false,
    });
  };

  toggleList = () => {
    if (this.props.disabled) {
      return;
    }
    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  };

  selectItem = (item) => {
    const { initMessage, value, list } = this.props;
    const { headerTitle } = this.state;
    const helpArr = [...value];

    let titleArr = [...headerTitle];

    titleArr.length === 1 &&
      (titleArr[0] === initMessage || titleArr[0] === '') &&
      titleArr.splice(0, 1);

    if (+item.value === 0) {
      if (helpArr.includes(item.value)) {
        for (let i = 0; i < helpArr.length; i++) {
          helpArr.splice(0, helpArr.length);
          titleArr.splice(0, titleArr.length);
        }
      } else {
        helpArr.splice(0, helpArr.length);
        titleArr.splice(0, titleArr.length);
        helpArr.push(item.value);
        titleArr.push(item.title);
        for (let i = 0; i < list.length; i++) {
          helpArr.push(list[i].value);
          titleArr.push(list[i].title);
        }
      }
    } else {
      if (helpArr.includes(item.value)) {
        for (let i = 0; i < helpArr.length; i++) {
          if (helpArr.length === list.length + 1) {
            helpArr.splice(0, 1);
            titleArr.splice(0, 1);
          }
          if (item.value === helpArr[i]) {
            helpArr.splice(i, 1);
            titleArr.splice(i, 1);
          }
        }
      } else {
        helpArr.push(item.value);
        titleArr.push(item.title);
      }
    }
    titleArr.length === 0 && titleArr.push(initMessage);
    const savedValue = helpArr;
    this.setState({
      headerTitle: titleArr,
      value: savedValue,
    });
    this.props.onChange(savedValue);
  };

  deleteValue = (item) => {
    const { value, list } = this.props;
    const { headerTitle } = this.state;
    const helpArr = [...value];
    const titleArr = [...headerTitle];

    list.map((elem) => {
      if (elem.title === item) {
        for (let i = 0; i < helpArr.length; i++) {
          if (elem.value === helpArr[i]) {
            helpArr.splice(i, 1);
          }
        }
      }
    });
    titleArr.map((elem, index) => {
      if (elem === item) {
        titleArr.splice(index, 1);
      }
    });

    const savedValue = helpArr;
    this.setState({
      headerTitle: titleArr,
      value: savedValue,
    });
    this.props.onChange(savedValue);
  };

  resetFilters = () => {
    const savedValue = [];
    this.setState({
      headerTitle: [],
      value: savedValue,
    });
    this.props.onChange(savedValue);
  };

  renderSearch = () => {
    const { listOpen, headerTitle } = this.state;
    const { dropdownInputField, initMessage } = this.props;

    if (listOpen) {
      return (
        <div className="input-component placeholder_small">
          <input
            type="text"
            autoFocus
            placeholder="Job Title/Study Role(s)…"
            onChange={(event) =>
              this.setState({ searchValue: event.target.value })
            }
            onFocus={() => this.setState({ searchValue: '' })}
          />
        </div>
      );
    }
    return (
      <div
        className={
          dropdownInputField === true && headerTitle === initMessage
            ? 'dd-header-title dd-header-title-small'
            : 'dd-header-title'
        }
      >
        {headerTitle.length > 0 ? (
          `${headerTitle.length} Job selected`
        ) : (
          <div className="fs-12" style={{ color: '#8A929B' }}>
            Job Title/Study Role(s)…
          </div>
        )}
      </div>
    );
  };

  render() {
    const {
      list,
      label,
      disabled,
      rowsCount,
      value,
      name,
      search,
      withMarginBottom,
      dataTestId,
    } = this.props;
    const { listOpen, headerTitle, searchValue } = this.state;

    let displayedList = searchValue
      ? list.filter(
          (listItem) =>
            listItem.title.toUpperCase().indexOf(searchValue.toUpperCase()) !==
            -1,
        )
      : list;

    if (!searchValue) {
      displayedList = [...displayedList];
    }
    const height =
      displayedList.length >= rowsCount
        ? (rowsCount + 1) * 40
        : (displayedList.length + 1) * 40;

    return (
      <div
        className="dd-wrapper"
        data-testid={`dropdown-${name}`}
        data-testid={dataTestId ? `dropdown-${dataTestId}` : `dropdown-${name}`}
      >
        <div
          className={classnames('dd-header', { _disabled: disabled })}
          onClick={this.toggleList}
          data-testid={dataTestId ? `${dataTestId}-header` : `dropdown-header`}
        >
          {label && <div className="dd-header-label">{label}</div>}
          {search ? (
            this.renderSearch()
          ) : (
            <div className="dd-header-title">{headerTitle}</div>
          )}
          <ArrowDown
            style={{ minWidth: '12px' }}
            className={listOpen ? 'arrow-down' : ''}
          />
        </div>
        {listOpen && (
          <div
            style={{ height: withMarginBottom ? '110px' : `${height}px` }}
            className="dd-list drop-list tag-list"
            onClick={(e) => e.stopPropagation()}
          >
            <Scrollbar>
              <ul
                style={{ width: '100%' }}
                data-testid={
                  dataTestId ? `${dataTestId}-list` : `dropdown-list-${name}`
                }
              >
                <li className="multi-for-filter-li">
                  <div
                    className="pointer flex justify-content-flex-end bold color-persian-red mt-2 mb-2 mr-3"
                    onClick={this.resetFilters}
                    data-testid="dropdown-reset-filter-button"
                  >
                    Reset filter
                  </div>
                </li>
                {displayedList.map((item, index) => (
                  <li
                    data-testid={`dropdown-item-${name}-${item.value}`}
                    data-testid={
                      dataTestId
                        ? `${dataTestId}-item`
                        : `dropdown-item-${name}`
                    }
                    key={index}
                  >
                    <Checkbox
                      name={item.value}
                      label={item.title}
                      testId={
                        dataTestId
                          ? `${dataTestId}-checkbox`
                          : `dropdown-checkbox-${name}`
                      }
                      labelClass={'filter-checkbox-class'}
                      isCheckedBox={
                        value.includes(item.value) && !item.disabled
                      }
                      addComponentClass={'multiCheckbox'}
                      isDisabledBox={item.disabled}
                      onChange={() => this.selectItem(item)}
                      searchValue={searchValue}
                      highlightMatch={true}
                      conversely
                    />
                  </li>
                ))}
              </ul>
            </Scrollbar>
          </div>
        )}

        {headerTitle.length > 0 && (
          <div className="dropdown-selected-wrapper">
            {headerTitle.map((item, index) => (
              <div key={index} className="dropdown-selected-tag">
                {item}
                <div onClick={() => this.deleteValue(item)}>
                  <CloseIcon className="pointer ml-2" />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

DropdownMultiWithTags.propTypes = {
  initMessage: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  list: PropTypes.array,
  disabled: PropTypes.bool,
  search: PropTypes.bool,
  rowsCount: PropTypes.number,
  showCheckIcon: PropTypes.bool,
  showAllOption: PropTypes.bool,
};

DropdownMultiWithTags.defaultProps = {
  initMessage: '',
  onChange: (e) => {},
  value: '',
  list: [],
  disabled: false,
  search: false,
  rowsCount: 6,
  showCheckIcon: false,
  showAllOption: false,
};

export default DropdownMultiWithTags;
